module.exports = __webpack_public_path__ + "img/vocal_warm_up.933b29eb.jpg";